import React from 'react';

import './_header.scss';

const Header = () =>
  (<header className="header">
      <a href="https://github.com/owtf/owtf"><img id="ribbon" src="https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67" alt="Fork me on GitHub" data-canonical-src="https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"/></a>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="header-content">
            <span className="header-logo">
              OWASP OWTF
            </span>
            <nav className="header-nav">
              <ul className="header-nav-list">
                <li className="header-nav-list-item">
                  <a href="#features">Features</a>
                </li>
                <li className="header-nav-list-item">
                    <a href="#download">Download</a>
                </li>
                <li className="header-nav-list-item">
                  <a href="https://medium.com/@owtf/">Blog</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js